import axios from 'axios';

const SERVICE_URL_AREAS = '/areas';
const SET_FAENAS = 'SET_FAENAS';
const SET_AREAS = 'SET_AREAS';

// Helper
function axiosConfig() {
  return { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
}

const circular = (a, _id) => (a && `${a._id}` === _id) || (a.area_padre && circular(a.area_padre, _id));
const asignarPadres = (areas) => {
  areas.forEach((a) => {
    if (a.area_padre_id) {
      // el try es por si es una asignacion circular
      try {
        const padre = areas.find(af => `${af._id}` === a.area_padre_id);
        // si el padre tiene como padre al id del hijo es circular
        a.area_padre = !circular(padre, `${a._id}`)
          ? padre
          : { error: `ERROR ASIGNACION CIRCULAR, buscar a quienes tengan area_padre_id ${a._id}` };
      } catch (e) {
        a.area_padre = { error: e };
      }
    }
  });
}

const borra = { me: null };
function putoIEAssign(o, k, v) {
  borra.me = o[k];
  o[k] = v;
  delete borra.me;
}

const state = {
  faenas: [],
  areas: [],
  new_area: {},
};


const getters = {
  faenas: state => state.faenas,
  areas: state => state.areas,
  new_area: state => state.new_area,
};


const actions = {
  // hay que vaciar las variables que cambian segun el rol
  // en las paginas se consulta si no tiene datos entonces intenta buscar
  // por eso la importancia de dejarlas vacias
  // en caso de no hacerlo tendria almacenadas las del anterior rol
  resetAreas({ commit }) {
    commit(SET_AREAS, []);
  },
  getFaenas({ commit }) {
    return axios.get(`${SERVICE_URL_AREAS}/faenas-min`, axiosConfig())
      .then((response) => {
        commit(SET_FAENAS, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },
  getAreasFaena({ commit }, id) {
    const faenaId = (localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')).faena_id) || id;
    return axios.get(`${SERVICE_URL_AREAS}/faena/${faenaId}`, axiosConfig())
    // return axios.post(`${SERVICE_URL_AREAS}/faenaWithTheirUsers`,{faena_id:faenaId}, axiosConfig())
      .then((response) => {
        asignarPadres(response.data)
        commit(SET_AREAS, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },
  getAreasbyFaena({ commit }, id) {
    return axios.get(`${SERVICE_URL_AREAS}/faena/${id}`, axiosConfig())
    // return axios.post(`${SERVICE_URL_AREAS}/faenaWithTheirUsers`,{faena_id:id}, axiosConfig())
      .then((response) => {
        asignarPadres(response.data)
        commit(SET_AREAS, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },
  getArbol({ commit }, faenaId) {
    return axios.get(`${SERVICE_URL_AREAS}/arbol-bhp/${faenaId}`, axiosConfig())
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },
  saveArea({ commit }, area) {
    return new Promise((resolve) => {
      axios.post(`${SERVICE_URL_AREAS}/crear`, area, axiosConfig())
        .then((response) => {
          resolve(response.data);
        });
    });
  },
  editArea({ commit }, area) {
    return new Promise((resolve) => {
      axios.post(`${SERVICE_URL_AREAS}/edit`, area, axiosConfig())
        .then((response) => {
          resolve(response.data);
        });
    });
  },
};

const mutations = {
  [SET_FAENAS](state, faenas) {
    putoIEAssign(state, 'faenas', faenas);
  },
  [SET_AREAS](state, areas) {
    putoIEAssign(state, 'areas', areas);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
